import { render, staticRenderFns } from "./HistoricoPunto.vue?vue&type=template&id=18c38b7f"
import script from "./HistoricoPunto.vue?vue&type=script&lang=js"
export * from "./HistoricoPunto.vue?vue&type=script&lang=js"
import style0 from "./HistoricoPunto.vue?vue&type=style&index=0&id=18c38b7f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports